module.exports = __webpack_public_path__ + "static/media/InProgress.0254db84.svg";